/* Karofi India storefront helpers: SVG country flags + scroll reveal. */
(() => {
  const base = window.kfAssetBase || '';
  const FLAG_RE = /([\u{1F1E6}-\u{1F1FF}])([\u{1F1E6}-\u{1F1FF}])/u;
  const RI_A = 0x1f1e6;

  // Windows has no flag emoji glyphs ("IN", "VN"...), so swap them for the theme's SVG flags.
  const swapFlags = (root) => {
    if (!base || !root || !root.querySelectorAll) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (FLAG_RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const m = node.nodeValue.match(FLAG_RE);
      if (!m) return;
      const code = String.fromCharCode(97 + m[1].codePointAt(0) - RI_A, 97 + m[2].codePointAt(0) - RI_A);
      const img = document.createElement('img');
      img.className = 'kf-flag';
      img.src = `${base}flag-${code}.svg`;
      img.alt = '';
      img.width = 20;
      img.height = 15;
      img.loading = 'lazy';
      const after = node.splitText(m.index);
      after.nodeValue = after.nodeValue.slice(m[0].length);
      node.parentNode.insertBefore(img, after);
      if (FLAG_RE.test(after.nodeValue)) swapFlags(node.parentNode);
    });
  };

  // Fade/slide-in for Karofi sections ([data-kf-reveal] children animate in sequence).
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io =
    !reduce && 'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                e.target.classList.add('is-in');
                io.unobserve(e.target);
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px' }
        )
      : null;
  const reveal = (root) => {
    root.querySelectorAll('[data-kf-reveal]:not(.is-in)').forEach((el) => {
      if (io) io.observe(el);
      else el.classList.add('is-in');
    });
  };

  // Mega menu (blocks/_mega_menu_products.liquid): switch panels on hover / focus / arrow keys.
  const initTabs = (root) => {
    root.querySelectorAll('[data-kf-tabs]:not([data-kf-ready])').forEach((wrap) => {
      wrap.dataset.kfReady = '';
      const tabs = [...wrap.querySelectorAll('[data-kf-tab]')];
      const panels = [...wrap.querySelectorAll('[data-kf-panel]')];
      const select = (i) => {
        tabs.forEach((t, n) => {
          t.setAttribute('aria-selected', String(n === i));
          t.tabIndex = n === i ? 0 : -1;
        });
        panels.forEach((p, n) => {
          p.setAttribute('aria-hidden', String(n !== i));
          p.toggleAttribute('inert', n !== i);
        });
      };
      tabs.forEach((t, i) => {
        t.addEventListener('mouseenter', () => select(i));
        t.addEventListener('focus', () => select(i));
        t.addEventListener('keydown', (e) => {
          const d = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          const n = (i + d + tabs.length) % tabs.length;
          select(n);
          tabs[n].focus();
        });
      });
      select(0);
    });
  };

  // Floating contact buttons: collapse behind an arrow toggle, plus a back-to-top button.
  const ICON_UP = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 15l6-6 6 6"/></svg>';
  const ICON_TOP = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V6M6 11l6-6 6 6M5 3h14"/></svg>';
  const initFab = () => {
    const box = document.querySelector('.floating-buttons');
    if (!box || box.dataset.kfFab !== undefined) return;
    box.dataset.kfFab = '';
    box.classList.add('kf-fab');
    const actions = [...box.querySelectorAll('.float-btn')];
    actions.forEach((a, i) => a.style.setProperty('--d', `${(actions.length - 1 - i) * 50}ms`));
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'kf-fab__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Contact options');
    toggle.innerHTML = ICON_UP;
    toggle.addEventListener('click', () => {
      const open = !box.classList.contains('is-open');
      box.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', (e) => {
      if (!box.contains(e.target) && box.classList.contains('is-open')) {
        box.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
    box.appendChild(toggle);

    const top = document.createElement('button');
    top.type = 'button';
    top.className = 'kf-to-top';
    top.setAttribute('aria-label', 'Back to top');
    top.innerHTML = ICON_TOP;
    top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }));
    document.body.appendChild(top);
    const onScroll = () => {
      const show = window.scrollY > 600;
      top.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('kf-top-visible', show);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  // Desktop COLLECTION mega menu: the panel rendered by blocks/_mega_menu_products.liquid is moved
  // out of the theme's <mega-menu> into our own dropdown under the navigation bar.
  const initMega = () => {
    document.querySelectorAll('[data-kf-mega-trigger]:not([data-kf-ready])').forEach((trigger) => {
      trigger.dataset.kfReady = '';
      const page = document.getElementById(trigger.dataset.kfMegaTrigger);
      const nav = trigger.closest('.header__navigation') || trigger.closest('nav');
      if (!page || !nav) return;
      const drop = document.createElement('div');
      drop.className = 'kf-mega';
      drop.setAttribute('role', 'region');
      drop.setAttribute('aria-label', trigger.textContent.trim());
      page.removeAttribute('aria-hidden');
      page.style.display = '';
      drop.appendChild(page);
      nav.appendChild(drop);
      initTabs(drop);
      let timer;
      const open = () => {
        clearTimeout(timer);
        drop.classList.add('is-open');
        document.documentElement.classList.add('kf-mega-open');
        trigger.setAttribute('aria-expanded', 'true');
      };
      const close = (delay = 160) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
          drop.classList.remove('is-open');
          document.documentElement.classList.remove('kf-mega-open');
          trigger.setAttribute('aria-expanded', 'false');
        }, delay);
      };
      [trigger, drop].forEach((el) => {
        el.addEventListener('mouseenter', open);
        el.addEventListener('mouseleave', () => close());
        el.addEventListener('focusin', open);
        el.addEventListener('focusout', (e) => {
          if (!drop.contains(e.relatedTarget) && e.relatedTarget !== trigger) close(0);
        });
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drop.classList.contains('is-open')) {
          close(0);
          trigger.focus();
        }
      });
    });
  };

  // Lead forms (snippets/kf-lead-form.liquid): fold extra answers into customer tags before submit.
  const initLeads = () => {
    document.querySelectorAll('form[data-kf-lead]:not([data-kf-ready])').forEach((form) => {
      form.dataset.kfReady = '';
      form.addEventListener('submit', () => {
        const tags = form.querySelector('[data-kf-tags]');
        if (!tags) return;
        const parts = [tags.dataset.kfBase];
        form.querySelectorAll('[data-kf-tag]').forEach((f) => {
          const v = (f.value || '').replace(/[,\n]/g, ' ').trim().slice(0, 80);
          if (v) parts.push(`${f.dataset.kfTag}: ${v}`);
        });
        tags.value = parts.filter(Boolean).join(', ');
      });
    });
  };

  // Real scrollbar width, used by CSS to keep 100vw sections from causing a horizontal scroll.
  const setScrollbarVar = () => {
    const w = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.style.setProperty('--kf-sbw', `${w}px`);
  };

  // Smooth in-page jump for [data-kf-scroll] links (e.g. sticky bar -> spec table).
  const initScrollLinks = () => {
    document.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('a[data-kf-scroll]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute('href'));
      if (!el) return;
      e.preventDefault();
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  // Count-up for stat numbers (e.g. "50+", "8M+", "~40,000 m²") when they scroll into view.
  const COUNT_SEL = '.kf-hero__stat-value, .kf-stat__value, .kf-mini-stat__value, .kf-map-stat__value, [data-kf-count]';
  const countUp = (el) => {
    const raw = el.textContent;
    const m = raw.match(/\d[\d,]*(\.\d+)?/);
    if (!m) return;
    const target = parseFloat(m[0].replace(/,/g, ''));
    if (!isFinite(target) || target === 0) return;
    const decimals = m[1] ? m[1].length - 1 : 0;
    const useComma = m[0].includes(',');
    const before = raw.slice(0, m.index);
    const after = raw.slice(m.index + m[0].length);
    const fmt = (v) => {
      const n = v.toFixed(decimals);
      return useComma ? Number(n).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : n;
    };
    const dur = Math.min(2200, 1200 + target.toString().length * 120);
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / dur);
      const e = 1 - Math.pow(1 - p, 4);
      el.textContent = before + fmt(target * e) + after;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = raw;
    };
    el.textContent = before + fmt(0) + after;
    requestAnimationFrame(tick);
  };
  let countIO;
  const initCounters = (root) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    countIO = countIO || new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { countIO.unobserve(e.target); countUp(e.target); }
    }), { threshold: 0.4 });
    const list = root.matches && root.matches(COUNT_SEL) ? [root] : [...root.querySelectorAll(COUNT_SEL)];
    list.forEach((el) => {
      if (el.dataset.kfCounted) return;
      el.dataset.kfCounted = '';
      countIO.observe(el);
    });
  };

  // Mobile swipe rows ([data-kf-scroller]): add prev/next arrows under the row.
  const initScrollers = (root) => {
    root.querySelectorAll('[data-kf-scroller]:not([data-kf-scroller-ready])').forEach((row) => {
      row.dataset.kfScrollerReady = '';
      const nav = document.createElement('div');
      nav.className = 'kf-scroller-nav';
      nav.innerHTML = '<button type="button" class="kf-scroller-btn" data-dir="-1" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button><button type="button" class="kf-scroller-btn" data-dir="1" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>';
      row.after(nav);
      const [prev, next] = nav.querySelectorAll('button');
      const update = () => {
        const max = row.scrollWidth - row.clientWidth - 2;
        nav.hidden = max <= 0;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max;
      };
      nav.addEventListener('click', (e) => {
        const b = e.target.closest('button');
        if (!b) return;
        const item = row.firstElementChild;
        const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0) : row.clientWidth;
        row.scrollBy({ left: step * Number(b.dataset.dir), behavior: 'smooth' });
      });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };

  // Mobile/tablet: the sticky add-to-cart bar sits at the bottom, so keep it visible while the header is revealed
  // (the theme hides it whenever the sticky header expands).
  const keepStickyCart = () => {
    document.addEventListener('sticky-header:update', () => {
      if (!window.matchMedia('(max-width: 1023px)').matches) return;
      setTimeout(() => {
        const bar = document.querySelector('sticky-add-to-cart');
        if (bar && bar.forceHidden) bar.forceHidden = false;
      }, 0);
    });
  };

  // Entrance for the theme's own sections (those without Karofi reveal): heading, then text, then
  // picture and actions, staggered, once as the section enters. Classes are added by script only,
  // so nothing stays hidden without it.
  const AUTO_SKIP = 'grid-carousel, slideshow-element, animation-element, product-form, form, [data-kf-reveal], .kf-sec, sticky-add-to-cart, .product-info, .product-gallery, header, footer';
  const AUTO_PARTS = 'h1, h2, h3, .heading, .rte, .prose, p, .button, img, video, picture';
  let autoIO;
  let autoT;
  const initAutoReveal = () => {
    if (reduce || !('IntersectionObserver' in window)) return;
    autoIO = autoIO || new IntersectionObserver((es) => es.forEach((e) => {
      if (!e.isIntersecting) return;
      autoIO.unobserve(e.target);
      e.target.classList.add('is-in');
    }), { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('main .shopify-section:not([data-kf-auto])').forEach((sec) => {
      if (sec.querySelector('[data-kf-reveal], .kf-sec, .product-info, slideshow-element')) { sec.dataset.kfAuto = ''; return; }
      // Content loaded later (recommendations, recently viewed) is picked up on the next pass.
      if (!sec.textContent.trim()) return;
      sec.dataset.kfAuto = '';
      let parts = [...sec.querySelectorAll(AUTO_PARTS)].filter((el) => !el.closest(AUTO_SKIP) && !el.parentElement.closest('.kf-auto-part'));
      // Carousels without the theme's own entrance: cards come in one after another.
      if (!sec.querySelector('animation-element, [animation]')) {
        sec.querySelectorAll('grid-carousel .product-card, grid-carousel .collection-list-item').forEach((card, n) => {
          card.classList.add('kf-auto-part', 'kf-auto-card');
          card.style.setProperty('--kf-d', `${120 + Math.min(n, 6) * 70}ms`);
        });
      }
      if (!parts.length && !sec.querySelector('.kf-auto-card')) {
        const first = sec.firstElementChild;
        const first2 = [...sec.children].find((c) => !c.matches('style, script, link'));
        if (!first2) return;
        parts = [first2];
      }
      const rank = (el) => (el.matches('h1, h2, h3, .heading') ? 0 : el.matches('.rte, .prose, p') ? 1 : 2);
      parts.slice(0, 24).forEach((el) => {
        el.classList.add('kf-auto-part');
        el.style.setProperty('--kf-d', `${rank(el) * 80}ms`);
      });
      sec.classList.add('kf-auto');
      autoIO.observe(sec);
    });
  };

  // Market switcher: close on outside click or Escape.
  const initMarket = () => {
    document.addEventListener('click', (e) => {
      document.querySelectorAll('details[data-kf-market][open]').forEach((d) => { if (!d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') document.querySelectorAll('details[data-kf-market][open]').forEach((d) => { d.open = false; });
    });
  };

  // Phones: the search icon opens the theme's mobile search panel when it exists,
  // otherwise it reveals the search field under the header and focuses it.
  const initSearchToggle = () => {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest && e.target.closest('[data-kf-search-toggle]');
      if (!btn) return;
      if (document.querySelector('search-panel-mobile')) {
        btn.dispatchEvent(new CustomEvent('search:open', { bubbles: true }));
        return;
      }
      const open = !document.documentElement.classList.contains('kf-search-open');
      document.documentElement.classList.toggle('kf-search-open', open);
      btn.setAttribute('aria-expanded', String(open));
      if (open) {
        const input = document.querySelector('.header__search--mobile input[type="search"], .header__search--mobile input[name="q"]');
        if (input) setTimeout(() => input.focus({ preventScroll: true }), 50);
      }
    });
  };

  const init = () => {
    setScrollbarVar();
    window.addEventListener('resize', setScrollbarVar, { passive: true });
    initMega();
    initLeads();
    initScrollLinks();
    initCounters(document);
    initScrollers(document);
    keepStickyCart();
    initAutoReveal();
    initMarket();
    initSearchToggle();
    initTabs(document);
    initFab();
    swapFlags(document.body);
    reveal(document);
    new MutationObserver((muts) => {
      muts.forEach((m) =>
        m.addedNodes.forEach((n) => {
          if (n.nodeType === 1) {
            swapFlags(n);
            reveal(n);
            initTabs(n);
            initCounters(n);
            initScrollers(n);
          }
        })
      );
      clearTimeout(autoT);
      autoT = setTimeout(initAutoReveal, 200);
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', (e) => { reveal(e.target); initAutoReveal(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
